import React from 'react'
import { ArrowRight } from "lucide-react";


const CTASection = ({ data, onApplyNow }) => {
    const cta = data.CTA;

    return (
        <section
            className="w-full bg-no-repeat bg-center bg-cover"
            style={{
                backgroundImage: "url('/bg.svg')"
            }}
        >
            <div className="w-full md:max-w-4xl mx-auto flex flex-col items-center justify-center py-10 md:py-14 lg:py-18 text-center">

                <h2 className="text-[20px] md:text-[25px] lg:text-[30px] xl:text-[42px] font-bold mb-6 leading-snug">
                    <span className="text-white">{cta.title}</span>{" "}
                    <span className="text-[#FFA201]">{cta.highlights}</span>
                </h2>
                <button
                    onClick={onApplyNow}
                    // href={cta.url}
                    className="relative group cursor-pointer bg-[#FFA201] px-6 py-2 rounded-none
                    text-black text-lg font-bold flex items-center justify-center gap-2
                    hover:bg-[#e89500] transition"
                >
                    {cta.btnName}

                    <ArrowRight
                        size={25}
                        className="transition-transform duration-300 rotate-45 group-hover:rotate-0"
                    />
                </button>
            </div>
        </section>
    )
}

export default CTASection